import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/error_hover.svg'


const _withScopeId = n => (_pushScopeId("data-v-46c3a1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "선택한 파일을 삭제하시겠습니까?")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("button", {
          class: "button__blue btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleConfirmClick()))
        }, "확인"),
        _createElementVNode("button", {
          class: "button__blue btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closePopup()))
        }, "취소")
      ])
    ])
  ]))
}